"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M14.088 3.932l.361.883H19v1.346H5V4.815h4.548l.361-.883a.713.713 0 01.661-.432h2.86c.291 0 .553.172.658.432zM8.674 20.5h6.652c1.4 0 2.536-1.096 2.536-2.45V7.827H6.138v10.224c0 1.352 1.136 2.448 2.536 2.448z" }), "Delete");
//# sourceMappingURL=Delete.js.map